import { render } from "./CustomAvatar2.vue?vue&type=template&id=5d5fc8f5"
import script from "./CustomAvatar2.vue?vue&type=script&lang=js"
export * from "./CustomAvatar2.vue?vue&type=script&lang=js"

import "./CustomAvatar2.vue?vue&type=style&index=0&id=5d5fc8f5&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__